
            const data = {"name":"icon-arrow-breadcrumb","data":{"viewBox":"0 0 5 12","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M4.886 5.716a.45.45 0 010 .569.314.314 0 01-.491 0L.102 1.305a.45.45 0 010-.569.314.314 0 01.49 0l4.294 4.98z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M4.395 5.716a.314.314 0 01.49 0 .45.45 0 010 .569l-4.293 4.98a.314.314 0 01-.49 0 .45.45 0 010-.57l4.293-4.98z\"/>"}}
        
                module.exports = data
                